<template>
    <div class="container-upload-centralizado">
        <div class="row">
            <div class="col-12 d-flex justify-content-center">
                <div class="input-group-wrapper">
                    <label :for="id" class="custom-file-upload">{{labelText}}</label>
                    <input type="file" :name="id" :id="id" :disabled="disable"
                           class="d-none" @change="uploadVideo" :required="isRequired" :accept="whoFiles" :multiple="multiple">
                    <span :name="id" class="form-error" />
                </div>
            </div>
        </div>
        
        <div class="row" v-if="loading_upload">
            <div class="col-12 d-flex flex-column align-items-center pt-3">
                <div class="spinner-border text-success" style="width: 3rem; height: 3rem;" role="status">
                </div>
                <p class="text-break mb-0 mt-2">Aguarde o upload do arquivo terminar...</p>
            </div>
        </div>
        
        <template v-if="files.length > 0">
            <div class="row wait-file my-3 mx-0" v-for="(item,index) in files" :key="index">
                <div class="col-12 col-md-8 d-flex align-items-center mb-2 mb-md-0">
                    <span title="Vizualizar Arquivo" class="file-item-name">
                        <i class="fas fa-file-alt icon-size-file"></i>
                        {{ item.file.name }}
                    </span>
                </div>
                <div class="col-12 col-md-4 d-flex justify-content-md-end justify-content-center">
                    <button type="button" class="react-btn btn-default btn-small btn-border btn-selecionar" @click="excluirAnexo(index)">
                        <i class="fa fa-trash" aria-hidden="true"></i><span class="btn-span-text"> Excluir</span>
                    </button>
                </div>
            </div>
        </template>
    </div>
</template>

<script>

    import { uploadFileToS3 } from '@/services/fileUploadService'
    import { avisoErro } from '@/config/global'

export default {
    emits: ['onSave','onDelete'],
    props: {
        labelText: {
            type: String,
            //required: true,
            default: 'Selecionar Arquivo',
        },
        fontSize: {
            type: String,
            default: '14px',
        },
        //fileLimitText: {
        //    type: String,
        //    default: 'Limite de arquivos até 800MB.',
        //},
         multiple: {
             type: Boolean,
             default: false,
         },
        // urlUpload: {
        //     type: String,
        //     required: true,
        // },
        // manualDisable: {
        //     type: Boolean,
        //     default: false
        // },
        customTextMuted: {
            type: String,
            default: ''
        },
        customSvgStyle: {
            type: String,
            default: ''
        },
        // hasListaUpload: {
        //     type: String,
        //     default: ''
        // },
        // hasVizualizar: {
        //     type: Boolean,
        //     default: false
        // },
        isRequired: {
            type: Boolean,
            default: false
        },
        whoFiles: {
            type: String,
            default: '.pdf,.doc,.docx'
        },
        maxFileSize: {
            type: Number,
            default: 800,
        },
        destino: {
            type: String,
            required: true,
        },
        dsHash: {
            type: String,
            default: '',
        },
        labelMaxPag:{
            type: String,
            default: ' MB.',
        },
        id: {
            type: String,
            default: 'input_file',
        },
        reset: {
            type: Boolean,
            default: false,
        },
        maxFiles: {
            type: Number,
            default: 3,
        },
    },
    data() {
        return {
            files: [],
            disable: false,
            hasFile: false,
            fileVizualizacao: '',
            loading_upload: false
        }

    },
    methods: {
        /**
        * Remove caracteres especiais do nome do arquivo
        * para evitar problemas na URL/Key do S3.
        * Mantém apenas letras, números, ponto, hífen e underline.
        */
        sanitizeFileName(name) {
            if (!name) return '';

            // Normaliza caracteres acentuados para remover diacríticos (á -> a, ç -> c, etc.)
            let sanitized = name.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

            // Remove qualquer caractere que não seja letra, número, ponto, hífen ou underline
            sanitized = sanitized.replace(/[^a-zA-Z0-9.\-_]/g, '');

            const i = sanitized.lastIndexOf('.');
            if (i > 0 && i < sanitized.length - 1) {
                sanitized = sanitized.slice(0, i + 1) + sanitized.slice(i + 1).toLowerCase();
            }

            return sanitized;
        },
        newHash() {
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let hash = '';

            for (let i = 0; i < 6; i++) {
                const randomIndex = Math.floor(Math.random() * characters.length);
                hash += characters.charAt(randomIndex);
            }

            return hash;
        },
        async uploadVideo(event) {
            let $this = this;
            var files = event.target.files || event.dataTransfer.files;
            if (!files.length) {
                return;
            }

            if ($this.multiple) {
                // verifica se selecionados agora são mais que permitido
                if (files.length > $this.maxFiles) {
                    avisoErro("Limite de arquivos atingido, são permitidos " + $this.maxFiles + " arquivos");
                    return;
                }
                // verifica se ja selecionados + selecionados agora são mais que permitido
                if ((files.length + $this.files.length) > $this.maxFiles) {
                    avisoErro("Limite de arquivos atingido, são permitidos " + $this.maxFiles + " arquivos");
                    return;
                }
            }

            for (var index = 0; index < files.length; index++) {
                let file = files[index]

                // Sanitiza o nome do arquivo para evitar caracteres especiais problemáticos (ex: "+")
                const sanitizedFileName = this.sanitizeFileName(file.name);
                
                let fsize = Math.round((file.size / 1024));
                if (fsize > ($this.maxFileSize * 1024)) {
                    avisoErro("Arquivo muito grande, selecione um arquivo de até " + $this.maxFileSize + "MB");
                    $this.excluirAnexo();
                    return null;
                } 

                let extensoesPermitidas = this.whoFiles.split(',');
                let extensao = file.name.split('.').pop().toLowerCase();
                if (!extensoesPermitidas.includes("." + extensao)) {
                    avisoErro("Formato inválido, selecione um arquivo " + $this.whoFiles);
                    $this.excluirAnexo();
                    return null;
                }

                try {
                    $this.loading_upload = true;
                    const uploaded = await uploadFileToS3(file, {
                        destino: $this.destino,
                        dsHash: $this.dsHash,
                    });
                    const payload = {
                        hash: uploaded.hash,
                        fileName: uploaded.fileName || sanitizedFileName,
                        file: file,
                        key: uploaded.key,
                    };
                   
                    if (!$this.multiple) {
                        $this.files[0] = payload;
                        $this.$emit('onSave', $this.files[0]);
                    } else {
                        $this.files.push(payload);
                        $this.$emit('onSave', $this.files);
                    }

                    $this.loading_upload = false;
                    $this.hasFile = true;
                } catch (error) {
                    avisoErro(error?.message || error);
                    $this.loading_upload = false;
                }
            }

            document.getElementById(this.id).value = null;
        },
        excluirAnexo(index) {
            
            this.$emit('onDelete', this.files[index].hash);
            this.files.splice(index, 1)

            document.getElementById(this.id).value = "";
            
            this.hasFile = false;
            // this.disable = false;
        },

        resetVariaveis() {
            this.files = [];
            this.loading_upload = false;
            // this.disable = false;
            this.hasFile = false;
            this.$emit('onSave', '');

            document.getElementById(this.id).value = null;
        },

    },
    watch: {
        reset() {
            this.resetVariaveis();
        }
    },
    mounted() {
        
    },


}
</script>

<style scoped lang="scss">
.container-upload-centralizado {
    width: 100%;
}

.input-group-wrapper {
    margin-top: 0.5rem;
    margin-bottom: 1rem;
}

.custom-file-upload {
    display: inline-block;
    padding: 6px 25px;
    cursor: pointer;
    background: linear-gradient(90deg, rgba(0, 81, 173, 1) 0%, rgba(0, 191, 81, 1) 100%);
    font-weight: 500;
    font-size: 16px;
    line-height: 26px;
    color: #FFF;
    border-radius: 4px;
}

.btn-white {
    border: 1px solid #AB0000;
}

.wait-file {
    font-size: 14px !important;
    border: 1px solid #e0e0e0;
    border-radius: 5px;
    padding: 15px;
    background-color: #f9f9f9;
}

.file-item-name {
    display: flex;
    align-items: center;
    word-break: break-word;
}

.icon-size-file {
    font-size: 24px;
    color: #34A853;
    margin-right: 10px;
    flex-shrink: 0;
}

.input-file-size {
    border-radius: 0px;
    min-height: 80px;
    height: 80px;
    width: 100%;
    max-width: 100%;
    border: 2px dashed grey;
    cursor: pointer;

    .anexo-title {
        font-size: 16px;
        color: #AB0000;
        margin-left: 15%;
        padding-top: 27px;
        font-size: 16px;
    }

    .text-muted {
        margin-left: 15%;
        padding-top: 7%;
        font-size: 14px;
    }
}

.svg-style {
    position: absolute;
    left: 22px;
    top: 15px
}

.mt-35 {
    margin-top: 35px;
}

.file-campo {
    border: 1px dashed #f4f4f4;
}

.btn-green {
    font-weight: 700;
    border-radius: 5px !important;
}

.btn-red {
    border-radius: 5px !important;
}

.line-card {
    max-width: 10px;
    margin-left: -3px;
    margin-top: -1px;
    margin-bottom: -2px;
}

.bg-color-red {
    background-color: #AB0000;
}

.bg-color-green {
    background: #34A853;
}

@media screen and (max-width: 768px) {
    .wait-file {
        text-align: center;
    }
    
    .file-item-name {
        justify-content: center;
    }
}

@media screen and (max-width: 1400px) {
    .input-file-size {
        .text-muted {
            margin-left: 25%;
        }

        .anexo-title {
            margin-left: 25%;
            padding-top: 1.5rem;
        }
    }

    .line-card {
        margin-left: 5px !important;
    }
}
</style>